import { useLayoutEffect } from 'react';

import { useBooleanState } from 'hooks';

import { LocaleButton } from './button/LocaleButton';
import { LocaleModal } from './modal/LocaleModal';

export const LocaleSwitcher = () => {
  const [isLocaleModalOpen, openLocaleModal, closeLocaleModal] =
    useBooleanState(false);

  useLayoutEffect(() => {
    document.body.style.overflow = isLocaleModalOpen ? 'hidden' : 'auto';
  }, [isLocaleModalOpen]);

  return (
    <>
      <LocaleModal isOpen={isLocaleModalOpen} onClose={closeLocaleModal} />
      <LocaleButton onClick={openLocaleModal} />
    </>
  );
};
